import { language as enIndexLanguage } from './en/index';
import { language as zhIndexLanguage } from './zh/index';
import { language as zh_CNIndexLanguage } from './zh_CN/index';
import { language as deIndexLanguage } from './de/index';
import { language as esIndexLanguage } from './es/index';
import { language as frIndexLanguage } from './fr/index';
import { language as zh_HKIndexLanguage } from './zh_HK/index';

export const languages = {
    en: {
        index: enIndexLanguage,
    },
    de: {
        index: deIndexLanguage,
    },
    es: {
        index: esIndexLanguage,
    },
    zh: {
        index: zhIndexLanguage,
    },
    zh_CN: {
        index: zh_CNIndexLanguage,
    },
    zh_HK: {
        index: zh_HKIndexLanguage,
    },
    fr: {
        index: frIndexLanguage,
    }
}